import { MediaObject } from "../types/MediaObject";
import { ReferenceFile } from "../types/ReferenceFile";
import ApiClient from "./ApiClient";
import dayjs from "dayjs";

export const getMediaObjectIdsFromSelectedMediaObjects = (
  selectedMediaObjects: ReferenceFile["selectedMediaObjects"]
) => {
  return selectedMediaObjects.map((mediaObject) => mediaObject.id);
};
const augmentSelectedMediaObjectsWithSelectionDate = (initialSelectedMediaObjects: ReferenceFile["selectedMediaObjects"], currentSelectedMediaObjectIds: Array<MediaObject["id"]>) => {
  let convertedSelectedMediaObjects = currentSelectedMediaObjectIds.map(mediaObjectId => ({ id: mediaObjectId, selectionDate: dayjs().toISOString()}))

  convertedSelectedMediaObjects.forEach(currentSelectedMediaObject => {
    const previousEntry = initialSelectedMediaObjects.find(initialSelectedMediaObject => initialSelectedMediaObject.id === currentSelectedMediaObject.id);
    if (previousEntry) {
      currentSelectedMediaObject.selectionDate = previousEntry.selectionDate;
    }
  });
  return convertedSelectedMediaObjects;
};

export const saveSelectedMediaObjects = async (referenceFile: ReferenceFile, selectedMediaObjects: Array<MediaObject["id"]>) => {
  await ApiClient.patch(referenceFile["@id"], {
    body: JSON.stringify({
      selectedMediaObjects: augmentSelectedMediaObjectsWithSelectionDate(referenceFile.selectedMediaObjects, selectedMediaObjects),
    }),
  });
};
